import React from 'react';

import { useUnmount } from 'react-use';
import { observer } from 'mobx-react';

import { taxStore } from '../../stores/taxStore';
import { useGetNecessaryData } from '../../../shared/hooks/useGetNecessaryData';
import { TaxInfoBlock } from '../../components/TaxInfoBlock/TaxInfoBlock';

type TaxWidgetProps = {
  entityId: number;
};

const TaxWidget = observer(({ entityId }: TaxWidgetProps) => {
  const { appliedTaxRateType, entityTaxRate, setTaxRate, getTaxInfo, setDefaultValues } =
    taxStore;

  useGetNecessaryData(async () => {
    await getTaxInfo(entityId);
  });
  useUnmount(setDefaultValues);

  return (
    <TaxInfoBlock
      taxRateInfo={entityTaxRate}
      description={
        <>
          Set up the combined SaaS tax, and sales tax percentages, based on the
          Entity&apos;s State/City taxes.
          <br />
          Upon tax setup, the subscription amount will be adjusted to reflect the
          applicable tax.
        </>
      }
      isActive={appliedTaxRateType.ENTITY_TAX_RATE}
      onSetTaxRate={setTaxRate}
    />
  );
});

export { TaxWidget };
